import React from 'react';
import { connect } from 'react-redux';
import { footerText } from '../../assets/constants/strings';
import PoweredBy from '../PoweredBy';

import './style.scoped.scss';

const Footer = ({
  isFixed,
  isAbsolute,
  isDocument,
  isCentered,
  showLogo,
  currentDocument,
}) => {

  return (
    <footer
      className={`footer d-flex justify-content-${isCentered ? 'center' : 'between'} align-items-center${isDocument ? ' document-footer' : ''}${isFixed ? ' fixed' : isAbsolute ? ' absolute' : ''
        }`}
    >
      {!isCentered && currentDocument !== null && (
        <p className="footer__text">
          {footerText()}
        </p>
      )}
      <PoweredBy isDocument={isDocument} showLogo={showLogo} />
    </footer>
  );
};

const mapStateToProps = (state) => ({
  currentDocument: state.document.currentDocument,
});

export default connect(mapStateToProps)(Footer);
